import request from '@/utils/request'

// 获取学生
export function getStudentList(params) {
  return request({
    url: '/educational/student/checkList',
    method: 'get',
    params: params
  })
}

// 新增学员
export function addStudent(data) {
  return request({
    url: '/educational/student',
    method: 'post',
    data: data
  })
}
